import { Offcanvas } from "bootstrap";
import debounce from "lodash/debounce";

const CLASS_OFFCANVAS = "offcanvas offcanvas-start";
const CLASS_D_NONE = "d-none";

let offcanvasLoaded = false;

const offcanvasWindowResize = debounce((showBs) => {
    const $filter = $("#catalog-filter");

    if (!$filter.length) return;

    offcanvasLoaded = true;

    if (window.innerWidth < 992) {
        $filter.removeClass(CLASS_D_NONE).addClass(CLASS_OFFCANVAS);
    } else {
        $filter.addClass(CLASS_D_NONE).removeClass(CLASS_OFFCANVAS);
        setTimeout(() => {
            $filter.css("visibility", "visible").attr("aria-hidden", "false");
        }, 300);
    }

    const bs = Offcanvas.getInstance($filter.get(0));

    if (bs !== null) {
        showBs ? bs.show() : bs.hide();
    }
}, 300);

$(document).on("click", ".catalog-filter-btn", function () {
    if (!offcanvasLoaded) {
        offcanvasWindowResize(true);
    }
});

window.addEventListener("resize", function () {
    offcanvasWindowResize();
});

export default offcanvasWindowResize;
